import React, {useEffect} from "react";
import { message, Tabs } from 'antd';
import "./index.css"
import {CaretDownOutlined, CaretUpOutlined} from "@ant-design/icons";
import emiter, { EVENT_CARRENTAL_STORE_RATING, EVENT_CARRENTAL_STORE_TEXT } from "../../../../events";
import { JSX } from "react/jsx-runtime";
import { NavLink } from "react-router-dom";

interface PropsType {
    enums?: any;
    errorContent?: string;
    permission?: any;
}

let tabScore = [
    {
        name: '规模分',
        scoreKey: 'scale_score',
        totalKey: 'scale_total_score',
        rateKey: 'scale_score_rate',
        contentKey: 'scale_score_content'
    },
    {
        name: '经营分',
        scoreKey: 'business_score',
        totalKey: 'business_total_score',
        rateKey: 'business_score_rate',
        contentKey: 'business_score_content'
    },
    {
        name: '合作分',
        scoreKey: 'cooperate_score',
        totalKey: 'cooperate_total_score',
        rateKey: 'cooperate_score_rate',
        contentKey: 'cooperate_score_content'
    },
    {
        name: '服务分',
        scoreKey: 'service_score',
        totalKey: 'service_total_score',
        rateKey: 'service_score_rate',
        contentKey: 'service_score_content'
    },
]
interface tabTitlePropsType {
    title?: String;
    score?: any;
    total?: any;
    rate?: any;
    content?: any;
    error?: any
}
const SPStoreRatingTabs: React.FC<PropsType> = (props) => {
    const {errorContent, permission } = props;

    const showTextEmpty = '--'

    const [showText, setShowText] = React.useState<any>({});

    const [showInfo, setShowInfo] = React.useState<any>({});

    const [tabsInfo, setTabsInfo] = React.useState<{ key: string; label: JSX.Element; children: JSX.Element; }[]>([]);

    const TabsHead= (event: { name: string; score: string; total: string; }) => {
        let {name, score, total} = event

        return <div title={score ? errorContent : errorContent}>
            {name}({score ?? showTextEmpty}/{total  ?? showTextEmpty})
        </div>
    }

    const InitScoreText = (event:{content:any})=>{
        let { content } = event
        let newTextArr = []
        if(content){
            if(content.link) {
                newTextArr = content.text.split(content.link)
            } else {
                newTextArr = [content.text];
            }
        }

        const authentication = (key: string,name:string) => {
            const showMenu = permission.find((item: any) => item?.key === key);
            return <>{
                showMenu ?
                    <NavLink to={key}>{name}</NavLink>
                    :
                    <span className='noLink' onClick={()=> message.error('抱歉，您无当前页面操作权限，请联系管理员协助开通')}>{name}</span>
            }</>
        }

        return (
            <div>
                {
                    newTextArr.length>0 ?
                    newTextArr.map((item:string,index:number)=>{
                        return index < newTextArr.length-1 ?
                            <span key={index}>{item}{authentication(content.router,content.link)}</span>
                            : <span key={index}>{item}</span>
                    }) :
                        <span title={errorContent}>{showTextEmpty}</span>
                }
            </div>
        )
    }
    const TabContent = (event: tabTitlePropsType) => {
        const {title, score, total, rate, content} = event
        //处理各分数文本
        return (
            <div className='tabsItemPage'>
                <div className='tabsItem'>
                    {title}:
                    <div title={score ? '' : errorContent} style={{ marginLeft:10 }}>
                        <span className='nowRating'>{score ?? showTextEmpty}</span>
                        <span style={{fontSize:'15px'}}>/{total ?? showTextEmpty}</span>
                        <span>分</span>
                    </div>
                    <div className='monthOnMonth'>
                        日环比
                        {
                            !rate ? <span title={errorContent}>{showTextEmpty}%</span>
                            : rate < 0 ?
                            <>下降
                                <span className='monthOnMonthBottom'><CaretDownOutlined/>{Math.abs(rate)}%</span>
                            </>:
                            <>上涨
                                <span className='monthOnMonthTop'><CaretUpOutlined/>{rate}%</span>
                            </>
                        }
                    </div>
                </div>
                <div title={content ? '' : errorContent}>
                    <InitScoreText content={content}/>
                </div>
            </div>
        )
    }

    const loadTabsInfo = () => {
        let newArr: { key: string; label: JSX.Element; children: JSX.Element; }[] = [];

        tabScore.forEach((item,index)=>{
            return newArr.push({
                key: index + '',
                label: <TabsHead name={item.name} score={showInfo?.[item.scoreKey]}
                                  total={showInfo?.[item.totalKey]}/>,
                children: <TabContent title={item.name} score={showInfo?.[item.scoreKey]}
                                    total={showInfo?.[item.totalKey]} rate={showInfo?.[item.rateKey]}
                                    content={showText?.[item.contentKey]}/>
            });
        })
        setTabsInfo(newArr);
    }

    useEffect(() => {
        loadTabsInfo()
    }, [showText,showInfo])

    const uodateShowInfo = (date:any) => {
        setShowInfo({...date})
    }

    const updateShowText = (data:any) => {
        if(Object.keys(data).length>0){
            setShowText({...data})
        }
    }

    useEffect(() => {
        emiter.on(EVENT_CARRENTAL_STORE_TEXT, updateShowText)
        emiter.on(EVENT_CARRENTAL_STORE_RATING, uodateShowInfo)
    }, [])

    return (
        <div className='tabsBody'>
            <Tabs
                type="card"
                defaultActiveKey="0"
                items={tabsInfo}
            />
        </div>
    )
}

export default SPStoreRatingTabs;